<template>
  <el-dialog
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="true"
    :title="$t('scripting.packageConfirmation')"
    :visible.sync="printTipsVisible"
    top="10vh"
    width="650px"
  >
    <div style="max-height: 500px; overflow-y: auto">
      <table class="confirm-table">
        <!-- 扫描信息 -->
        <tr>
          <td class="label">{{ $t('collectionCenter.scanInfo') }}:</td>
          <td class="value" colspan="2">{{ tipDataList[0].invoiceAccessKey || '-' }}</td>
        </tr>
        <!-- 关联包裹数量 -->
        <tr>
          <td class="label">{{ $t('scripting.associatedPackageCount') }}:</td>
          <td class="value" colspan="2">{{ tipDataList.length || 0 }}</td>
        </tr>
        <!-- 第一行运单 -->
        <tr>
          <td class="label">{{ $t('scripting.packageWaybillNumber') }}:</td>
          <td class="value">{{ tipDataList[0].waybillNumber || '-' }}</td>
        </tr>
        <!-- 剩下的运单行 -->
        <tr v-for="(item, index) in (tipDataList || []).slice(1)" :key="index">
          <td class="label" />
          <td class="value">{{ item.waybillNumber }}</td>
        </tr>
      </table>
    </div>
    <div style="margin-left: 30px; color: red">{{ $t('scripting.verifyPackageCountNotice') }}</div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="printTipsVisible = false">
        {{ $t('scripting.cancelPrint') }}
      </el-button>
      <el-button size="small" type="primary" @click="clickPrint">
        {{ $t('GlobalSetObj.Confirmed') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'PackageConfirmDialog',
  data() {
    return {
      printTipsVisible: false,
      tipDataList: []
    };
  },
  methods: {
    showTip(arg) {
      this.tipDataList = arg;
      this.printTipsVisible = true;
    },
    clickPrint() {
      this.$emit('autoPrint');
      this.printTipsVisible = false;
    }
  }
};
</script>

<style scoped>
.confirm-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 16px;
}

.confirm-table .label {
  padding: 5px;
  text-align: right;
  white-space: nowrap;
  width: 1%;
}

.confirm-table .value {
  padding: 5px;
  color: #409eff;
  word-break: break-all;
}

.confirm-table .operate {
  padding: 5px;
  text-align: center;
  cursor: pointer;
  color: red;
  width: 1%;
  white-space: nowrap;
}

.dialog-footer {
  text-align: right;
  margin-top: 8px;
}
</style>
